export default "__VITE_ASSET__DoEBidwh__"